import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { OrderDirection } from '../../Datatable/OrderDirection';
import ExpenseModel from '../models/ExpenseModel';
import { QueryItem } from '../../Tonnage/models/TonnageQueryModel';
import ExpenseQueryModel from '../models/ExpenseQueryModel';
import ExpenseAnalyticsModel from '../models/ExpenseAnalyticsModel';

interface ExpenseSearchState {
    query: ExpenseQueryModel,
    searchResults: ExpenseAnalyticsModel[],
    ExpenseSearchKeyword: string,
    triggerSearch: number,
    selectedExpenses: ExpenseModel[],
    datatableSelectedIndex: number,
    searchResultTotalRecord: number,
    triggerFocusCompanyName: number
    checkedExpenses: ExpenseModel[],
    componentType: string,
}

const initialState: ExpenseSearchState = {
    query: {
        items: [],
        types: [],
        currencies: [],
        orderBy: "updatedDate",
        orderDirection: OrderDirection.Desc,
    } as ExpenseQueryModel,
    searchResults: [],
    ExpenseSearchKeyword: "",
    selectedExpenses: [],
    triggerSearch: 0,
    datatableSelectedIndex: -1,
    searchResultTotalRecord: 0,
    triggerFocusCompanyName: 0,
    checkedExpenses: [],
    componentType: ""
}

export const ExpenseSearchSlice = createSlice({
    name: "ExpenseSearch",
    initialState,
    reducers: {
        setItems: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.items = action.payload;
        },
        setTypes: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.types = action.payload;
        },
        setOrderBy: (state, action: PayloadAction<string>) => {
            state.query.orderBy = action.payload;
        },
        setOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.query.orderDirection = action.payload;
        },
        setExpenseSearchResults: (state, action: PayloadAction<ExpenseAnalyticsModel[]>) => {
            state.searchResults = action.payload;
        },
        setTriggerExpenseSearch: (state, action: PayloadAction<number>) => {
            state.triggerSearch = action.payload;
        },
        setExpenseSearchKeyword: (state, action: PayloadAction<string>) => {
            state.ExpenseSearchKeyword = action.payload;
        },
        setDatatableSelectedExpenseIndex: (state, action: PayloadAction<number>) => {
            state.datatableSelectedIndex = action.payload;
        },
        setSearchResultTotalRecord: (state, action: PayloadAction<number>) => {
            state.searchResultTotalRecord = action.payload;
        },
        setExpensequery: (state, action: PayloadAction<ExpenseQueryModel>) => {
            state.query = action.payload;
        },
        resetExpenseSearch: (state) => {
            state.query = initialState.query;
        },
        setSelectedExpenses: (state, action: PayloadAction<ExpenseModel[]>) => {
            state.selectedExpenses = action.payload;
        },
        setTriggerFocusCompanyName: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyName = action.payload;
        },
        setCheckedExpenses: (state, action: PayloadAction<ExpenseModel[]>) => {
            state.checkedExpenses = action.payload;
        },
        setComponentType: (state, action: PayloadAction<string>) => {
            state.componentType = action.payload;
        },
        resetQuery: (state) => {
            state.query = initialState.query;
        }
    }
});

export const ExpenseSearchSelector = createSelector(
    (state: RootState) => state.ExpenseSearch,
    (data) => data
);

export const {
    setItems,
    setTypes,
    setOrderBy,
    setExpenseSearchKeyword,
    setOrderDirection,
    setExpenseSearchResults,
    setTriggerExpenseSearch,
    setDatatableSelectedExpenseIndex,
    setSearchResultTotalRecord,
    setExpensequery,
    resetExpenseSearch,
    setSelectedExpenses,
    setTriggerFocusCompanyName,
    setCheckedExpenses,
    setComponentType,
    resetQuery
} = ExpenseSearchSlice.actions;

export default ExpenseSearchSlice.reducer;